import { get } from 'lodash';

import EMPLOYER_WORKFLOW_STATUS from '../constants/EmployerWorkflowStatus';
import RECRUITER_WORKFLOW_STATUS from '../constants/RecruiterWorkflowStatus';
import ATS_SUBMIT_STATUS from '../constants/AtsSubmitStatus';
import ATS_SYNC_STATUS_LABEL from '../constants/AtsSyncStatusLabel';
import { EMPLOYER_ROLE } from '../constants/UserRole';
import { WorkflowEventType } from '../constants/WorkflowEventsConstants';

export default class WorkflowService {
    static getValidRejectionReason({ workflow }) {
        const employerStatus = get(workflow, 'employerStatus.current');
        const recruiterStatus = get(workflow, 'recruiterStatus.current');
        const employerReason = get(workflow, 'employerStatus.reason');
        const recruiterReason = get(workflow, 'recruiterStatus.reason');
        if (employerStatus === EMPLOYER_WORKFLOW_STATUS.REJECTED && employerReason && employerReason !== 'N/A') {
            return employerReason;
        }

        if (recruiterStatus === RECRUITER_WORKFLOW_STATUS.REJECTED && recruiterStatus && recruiterStatus !== 'N/A') {
            return recruiterReason;
        }

        return employerStatus === EMPLOYER_WORKFLOW_STATUS.REJECTED ? employerReason : recruiterReason;
    }

    static isUniqueCandidate = ({
        position,
        workflow,
    }) => {
        const isLiSyncPosition = get(position, 'linkedinSyncProjectId');
        const isLiSyncWorkflow = get(workflow, 'isLinkedinSyncCandidate');
        const isAtsSyncPosition = get(position, 'atsSettings.atsJobId');
        const isAtsSyncWorkflow = get(workflow, 'isAtsSyncCandidate');

        return (isAtsSyncPosition || isLiSyncPosition)
        && !((isLiSyncPosition && isLiSyncWorkflow) || (isAtsSyncPosition && isAtsSyncWorkflow));
    };

    static isSyncInProgress = (candidate) => candidate?.atsSyncStatus?.current === ATS_SUBMIT_STATUS.STARTED;

    static getSyncStatusLabel({ atsSyncStatus }) {
        switch (atsSyncStatus?.current) {
            case ATS_SUBMIT_STATUS.STARTED: {
                return ATS_SYNC_STATUS_LABEL.SYNC_IN_PROGRESS;
            }
            case ATS_SUBMIT_STATUS.SUBMITED:
            case ATS_SUBMIT_STATUS.RESUBMITED:
            case ATS_SUBMIT_STATUS.SYNCED:
            case ATS_SUBMIT_STATUS.RESYNCED: {
                return ATS_SYNC_STATUS_LABEL.SYNCED;
            }
            case ATS_SUBMIT_STATUS.FAILED: {
                return ATS_SYNC_STATUS_LABEL.SYNC_IN_PROGRESS;
            }
            default: return '';
        }
    }
}

export class WorkflowContactCandidateEvent {
    eventType = WorkflowEventType.EMPLOYER_CONTACT_CANDIDATE;

    constructor(isInvite, entityRole, entityId, employer, type = null) {
        this.content = {
            type: type || 'linkedin',
            subType: isInvite ? 'invite' : 'message',
            message: entityRole === EMPLOYER_ROLE
                ? `Employer ${employer?.name ?? ''} contacted Candidate`
                : 'Talent Expert contacted Candidate',
        };
        this.entityId = entityId;
        this.entityRole = entityRole;
    }
}
